/**
 * @generated SignedSource<<c86a4702e708a7bdd62c2dba894d220a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ClassificationLevelSource = "AUTO" | "CONTENT" | "NONE" | "ORGANIZATION" | "SPACE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useContentClassification_content$data = {
  readonly classificationLevelDetails: {
    readonly canManageSpaceSettings: boolean;
    readonly classificationControlSetting: string | null;
    readonly classificationLevel: {
      readonly color: string | null;
      readonly description: string | null;
      readonly guideline: string | null;
      readonly guidelineADF: string | null;
      readonly id: string;
      readonly name: string;
      readonly status: string;
    } | null;
    readonly featureEnabled: boolean;
    readonly isReclassificationPermitted: boolean;
    readonly source: ClassificationLevelSource | null;
    readonly userOverrideSetting: string | null;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "useContentClassification_content";
};
export type useContentClassification_content$key = {
  readonly " $data"?: useContentClassification_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useContentClassification_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useContentClassification_content",
  "selections": [
    (v0/*: any*/),
    {
      "concreteType": "ClassificationLevelDetails",
      "kind": "LinkedField",
      "name": "classificationLevelDetails",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentDataClassificationLevel",
          "kind": "LinkedField",
          "name": "classificationLevel",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "guideline"
            },
            {
              "kind": "ScalarField",
              "name": "guidelineADF"
            },
            {
              "kind": "ScalarField",
              "name": "description"
            },
            {
              "kind": "ScalarField",
              "name": "color"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "status"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "featureEnabled"
        },
        {
          "kind": "ScalarField",
          "name": "source"
        },
        {
          "kind": "ScalarField",
          "name": "isReclassificationPermitted"
        },
        {
          "kind": "ScalarField",
          "name": "canManageSpaceSettings"
        },
        {
          "kind": "ScalarField",
          "name": "classificationControlSetting"
        },
        {
          "kind": "ScalarField",
          "name": "userOverrideSetting"
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "c8de016d394e3db37049853fe1de9452";

export default node;
